<div class="container-fluid p-0">
    <div class="row">
        <div class="col-md">
            Page not found - 404
        </div>
    </div>
</div>